module.exports = __webpack_public_path__ + "static/media/bell-church1.84a41ee8.aac";